import React from 'react'
import ReactDOM from 'react-dom'
import { getVersionTip } from '@utils/intl_lang'
import stores from '@stores'
import { IsAvailableIEVersion } from '@utils'
import styles from './index.module.less'

// IE版本号
const version = 11

/**
 * 渲染IE11兼容信息
 */
export const renderIECompatibility = ()=>{
  const isIE11 = IsAvailableIEVersion(version)
  if (isIE11) {
    ReactDOM.render((
      <div className={styles.container}>
        <div className={styles.image}>
          <p className={styles.tip}>
            {/* {`抱歉，您的浏览器版本过低可能影响e祺学网页版部分功能的使用。请升级到IE${version}及以上的浏览器或使用chrome浏览器打开e祺学网页版。`} */}
            {getVersionTip(stores.IntlCommon.browserLanguage, version)}
          </p>
        </div>
      </div>
    ), document.getElementById('root'))
    return true
  }
  return false
}
